import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const ClockIcon: React.FC<Props> = () => {
  return (
    <SVGIcon width="20" height="20" viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 4C7.44772 4 7 4.44772 7 5V8C7 8.26522 7.10536 8.51957 7.29289 8.70711L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L9 7.58579V5C9 4.44772 8.55228 4 8 4Z"
        fill="#2B2B2B"
      />
    </SVGIcon>
  );
};

export default ClockIcon;
